<template>
  <div class="web-date-picker">
    <select class="day" v-model="day">
      <option v-for="(number, index) in 31" :value="number" :key="index">{{ number }}</option>
    </select>

    <select class="month" v-model="month">
      <option v-for="(number, index) in 12" :value="index" :key="index">{{ monthName(index) }}</option>
    </select>

    <select class="year" v-model="year">
      <option v-for="currentYear in years" :value="currentYear" :key="'currentYear_'+currentYear">{{ currentYear }}</option>
    </select>
  </div>
</template>

<script>

const modelProp = 'date'
const modelEvent = 'dateChange'

export default {
  model: {
    prop: modelProp,
    event: modelEvent
  },
  props: {
    date: {}
  },
  data: () => ({
    object: new Date(),
    years: []
  }),
  computed: {
    year: {
      get () {
        return this.object.getFullYear()
      },
      set (value) {
        this.validate(parseInt(value) || 0, this.object.getMonth(), this.object.getDate())
      }
    },
    month: {
      get () {
        return this.object.getMonth()
      },
      set (value) {
        this.validate(this.object.getFullYear(), parseInt(value) || 0, this.object.getDate())
      }
    },
    day: {
      get () {
        return this.object.getDate()
      },
      set (value) {
        this.validate(this.object.getFullYear(), this.object.getMonth(), parseInt(value) || 1)
      }
    }
  },
  watch: {
    date: {
      immediate: true,
      handler (to) {
        if (to instanceof Date) {
          this.object = to
        } else if (typeof to === 'string') {
          this.object = new Date(to)
        } else {
          this.object = new Date()
        }
      }
    },
    object: {
      immediate: true,
      handler (value, oldValue) {
        this.$emit(modelEvent, {
          object: this,
          eventName: modelEvent,
          oldValue,
          propertyName: modelProp,
          value
        })
      }
    }
  },
  methods: {
    validate (year, month, day) {
      let date = new Date()
      let check = () => {
        date.setFullYear(year)
        date.setMonth(month, day)

        if (date.getFullYear() !== year || date.getMonth() !== month || date.getDate() !== day) {
          --day

          check()
        }
      }

      check()

      this.object = date
    },
    monthName (index) {

      let date = new Date()

      date.setMonth(index, 2)

      return date.toLocaleString('default', {month: 'long'});
    }
  },
  created () {
    // add current year and 100 years before
    let year = new Date().getFullYear()

    for (let i = year - 100; i <= year; i++) {
      this.years.push(i)
    }
  }
}

</script>

<style lang="scss" scoped>

html {
  .web-date-picker > * {
    height: 56px;
    margin: 0 0 0 20px;
  }

  .day {
    margin-left: 0;
  }

  .year {
    width: 70px;
  }
}

</style>